<template>
	<div>
		<div v-if="coupon.open_type == 1" class="container-fluid" v-html="coupon.content"></div>
		<div v-else>
			<div class="column full">
				<div class="py-3">
					<h4 class="size-28 text-center">{{ $t('coupon.null_title') }}</h4>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["coupon"],
};
</script>

<style lang="scss">
</style>